import { render } from "./PlaceholdersPage.vue?vue&type=template&id=fadfe8c4&ts=true"
import script from "./PlaceholdersPage.vue?vue&type=script&lang=ts"
export * from "./PlaceholdersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__